import axios from 'axios'

const API_PATH = '/api/v2/customers/products/brands'

const CustomerProductsBrandsApi = {
  /**
   * Get Brands
   * @return {object} brand options for FastSelling Product
   */
  get: async ({ additionalFilters }) => {
    const params = additionalFilters

    const response       = await axios.get(API_PATH, { params })
    const responseBrands = response.data.brands

    return responseBrands
  }

}

export default CustomerProductsBrandsApi
